import React from 'react';
import { Dialog } from 'primereact/dialog';

const DetalhesModal = ({ visible, onHide, merchandise }) => {
    if (!merchandise) return null;
    
    return (
        <Dialog header="Detalhes do Produto" visible={visible} style={{ width: '50vw' }} onHide={onHide}>
            <p><strong>Família:</strong> {merchandise.family || 'Sem família'}</p>
            <p><strong>Nome:</strong> {merchandise.name}</p>
            <p><strong>Categoria:</strong> {merchandise.category}</p>
            <p><strong>Referência:</strong> {merchandise.reference}</p>
            <p><strong>Stock Mínimo:</strong> {merchandise.minimum_stock}</p>
            <p><strong>Stock Máximo:</strong> {merchandise.maximum_stock}</p>
            <p><strong>Quantidade por Caixa:</strong> {merchandise.quantity_per_box}</p>
            <p><strong>Certificado:</strong> {merchandise.certificate || '-'}</p>
            <p><strong>Barcode:</strong> {merchandise.barcode || '-'}</p>
            <p><strong>Número da Guia:</strong> {merchandise.guide_number || '-'}</p>
            <p><strong>Guia:</strong> {merchandise.guide || '-'}</p>
        </Dialog>
    );
};

export default DetalhesModal;
